export const entries = {
    'qhd': {
        'development': '//localhost:8080/',
        // 'development': 'http://test.yuxisoft.cn:20202/',
        'test': 'http://test.yuxisoft.cn:20202/',
        'production': 'https://cloud-interaction2-cms.yuxisoft.cn/'
    },
    'beauty': {
        'development': '//localhost:3000/',
        'development': 'https://member-store-beauty-cms-test.yuxisoft.cn/',
        'test': 'https://member-store-beauty-cms-test.yuxisoft.cn/',
        'production': 'https://member-store-beauty-cms.yuxisoft.cn/'
    }
}